export default __webpack_public_path__ + "static/media/Money-jee.fcb7d496.svg";